import { Divider } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  analytics_cards,
  analytics_cards_all,
  analytics_cards_export,
} from "../../actions/cards/cards";
import { amountFormat } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import ReportTable from "./ReportTable";
import MISAdvances from "../Common/PDF/MISPDF/MISAdvances";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

const Advances = (props) => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.analytics.analytics_cards);
  const pdfData = useSelector((state) => state.analytics.analytics_cards_all);

  useEffect(() => {
    dispatch(analytics_cards({ type: "advances" }));
    dispatch(analytics_cards_all({ type: "advances", csv: true }));
    dispatch(
      analytics_cards_export({ pdf: true, csv: true, type: "advances" })
    );
    props.setFilterObj({});
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.pdfURL(downloadPdf)
  }, [pdfData])

  const downloadPdf = async () => {
    const blob = await pdf((
      <MISAdvances data={pdfData?.data?.response?.report || []} />
    )).toBlob();
    saveAs(blob, "MISAdvances.pdf");
  }

  const getObjs = () => {
    if (cards?.data?.response?.report?.length > 0) {
      return cards?.data?.response?.report?.[0]?.custom_fields?.map(ele => ({
        title: ele.key?.replace("_", " "),
        dataIndex: "custom_fields",
        key: "custom_fields",
        render: (text, data) => <div>{data?.custom_fields?.find(itm => itm.key === ele.key)?.value}</div>,
      }))
    }

    return []
  }

  const handlePaginationCall = (vals) => {
          vals.type = "advances";
          
          const finalVals = {};
          for (const key in vals) {
            if (Array.isArray(vals[key])) {
              finalVals[key] = vals[key].join(',');
            } else {
              finalVals[key] = vals[key];
            }
          }
          
          dispatch(analytics_cards(finalVals));
          dispatch(analytics_cards_export({ pdf: true, csv: true, ...finalVals }));
        }

  const columns = [
    {
      title: "Advance ID",
      dataIndex: "advance_id",
      key: "advance_id",
      render: (text, data) => {
        return <div className={`render_common_style status_${data?.Status}`}>{text}</div>;
      },
    },
    {
      title: "Purpose or Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Date and Time",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Recorded By",
      dataIndex: "submitted_by",
      key: "submitted_by",
    },
    {
      title: "Reference",
      dataIndex: "reference_number",
      key: "reference_number",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => <div> <BaseCurrency /> {amountFormat(text)}</div>,
    },
    ...getObjs(),
    {
      title: "Cost center",
      dataIndex: "cost_center",
      key: "cost_center",
    },
    {
      title: "Project",
      dataIndex: "project",
      key: "project",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <div className={`status status_${text}`}>{text}</div>,
    },
  ];

  return (
    <>
      <div className="reports">
        <Divider />
      </div>
      <ReportTable
        columns={columns}
        data={cards?.data?.response?.report || []}
        total_records={cards?.data?.total_records}
        paginationCall={handlePaginationCall}
        payload={{ ...props.filterObj, ...props.apiFilters }}
        scroll={{ x: 1400 }}
      />
    </>
  );
};

export default Advances;
